import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Live from '../pages/live/index.vue'/* 直播 */
import LiveRoom from '../pages/live/room.vue'/* 直播内容 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import RechargeRecord  from '../pages/mine/RechargeRecord'/* 充值记录 */
import CrushList  from '../pages/mine/CrushList'/* 心动名单 */
import Account  from '../pages/mine/Account'/* 账户详情 */
import PlatformRule from '../pages/mine/PlatformRule.vue'/* 平台规则 */
import CryptoBind from '../pages/mine/CryptoBind.vue'/* 虚拟货币提现 */


Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{titleKey:'browserTitle.home'}},
    {path:'/Home',name:'home',component:Home,meta:{titleKey:'browserTitle.home'}},
        {path:'/Choose',name:'choose',component:Choose,meta:{titleKey:'browserTitle.choose'}},
        {path:'/List',name:'list',component:List,meta:{titleKey:'browserTitle.list'}},
        {path:'/Profile',name:'profile',component:Profile,meta:{titleKey:'browserTitle.profile'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{titleKey:'browserTitle.mine'}},
    {path:'/Video',name:'video',component:Video,meta:{titleKey:'browserTitle.video'}},
    {path:'/Live',name:'live',component:Live,meta:{titleKey:'browserTitle.live'}},
    {path:'/LiveRoom',name:'liveRoom',component:LiveRoom,meta:{titleKey:'browserTitle.liveRoom'}},
    {path:'/Game',name:'game',component:Game,meta:{titleKey:'browserTitle.game'}},
    {path:'/Login',name:'login',component:Login,meta:{titleKey:'browserTitle.login'}},
    {path:'/Register',name:'register',component:Register,meta:{titleKey:'browserTitle.register'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{titleKey:'browserTitle.serviceOnline'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{titleKey:'browserTitle.servicePage'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{titleKey:'browserTitle.setting'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{titleKey:'browserTitle.infomation'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{titleKey:'browserTitle.setname'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{titleKey:'browserTitle.setsex'}},
    {path:'/Language',name:'Language',component:Language,meta:{titleKey:'browserTitle.language'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{titleKey:'browserTitle.recharge'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{titleKey:'browserTitle.setPayPassword'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{titleKey:'browserTitle.setLoginPassword'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{titleKey:'browserTitle.lottery'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{titleKey:'browserTitle.notice'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{titleKey:'browserTitle.playVideo'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{titleKey:'browserTitle.setbank'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{titleKey:'browserTitle.bindCard'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{titleKey:'browserTitle.withdraw'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{titleKey:'browserTitle.personalreport'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{titleKey:'browserTitle.withdrawRecord'}},
    {path:'/RechargeRecord',name:'RechargeRecord',component:RechargeRecord,meta:{titleKey:'browserTitle.rechargeRecord'}},
    {path:'/CrushList',name:'CrushList',component:CrushList,meta:{titleKey:'browserTitle.crushList'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{titleKey:'browserTitle.gameRecord'}},
    {path:'/Account',name:'Account',component:Account,meta:{titleKey:'browserTitle.account'}},
    {path:'/PlatformRule',name:'PlatformRule',component:PlatformRule,meta:{titleKey:'browserTitle.platformRule'}},
    {path:'/CryptoBind',name:'CryptoBind',component:CryptoBind,meta:{titleKey:'browserTitle.cryptoBind'}},
    {path:'/Guide',name:'Guide',component:()=>import('@/pages/home/guide'),meta:{titleKey:'browserTitle.guide'}},
    {path:'/VipCard',name:'VipCard',component:()=>import('@/pages/mine/VipCard'),meta:{titleKey:'browserTitle.vipCard'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})

export default router
